import { render } from "./KeyMessages.vue?vue&type=template&id=6c887e37&scoped=true"
import script from "./KeyMessages.vue?vue&type=script&lang=js"
export * from "./KeyMessages.vue?vue&type=script&lang=js"

import "./KeyMessages.vue?vue&type=style&index=0&id=6c887e37&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2362541812/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c887e37"]])

export default __exports__